import React, { useState } from 'react';
import { Chip, Button } from '@mui/material';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import EmailIcon from '@mui/icons-material/Email';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { useBandView } from '../../../../contexts/BandViewContext';
import PromoterInterestModal from '../../../public/PromoterInterestModal';

interface StatusActionDisplayProps {
  status: 'pending' | 'approved' | 'rejected';
  bandName: string;
  strandName?: string; // Add optional strand name prop
}

const StatusActionDisplay: React.FC<StatusActionDisplayProps> = ({
  status,
  bandName,
  strandName
}) => {
  const { viewMode } = useBandView();
  const [modalOpen, setModalOpen] = useState(false);

  const handleBookBand = () => {
    const subject = encodeURIComponent(`Booking Inquiry for ${bandName}${strandName ? ` - ${strandName}` : ''}`);
    const bodyContent = strandName 
      ? `Hi Kenneth, I'm interested in booking ${bandName} for the ${strandName} event.\n\nBand Details: ${window.location.href}`
      : `Hi Kenneth, I'm interested in booking ${bandName}.\n\nBand Details: ${window.location.href}`;
    
    const body = encodeURIComponent(bodyContent);
    window.location.href = `mailto:ken@improvisedmusic.ie?subject=${subject}&body=${body}`;
  };

  if (viewMode === 'public') {
    return (
      <>
        <Button
          variant="contained"
          startIcon={<HandshakeIcon />}
          onClick={() => setModalOpen(true)}
          sx={{
            position: 'absolute', top: 20, right: 20,
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(80,227,194,0.9)',
            color: '#0a0a0f',
            fontWeight: 700,
            '&:hover': { backgroundColor: 'rgba(80,227,194,1)' },
          }}
        >
          Express Interest
        </Button>
        <PromoterInterestModal
          open={modalOpen}
          bandName={bandName}
          onClose={() => setModalOpen(false)}
        />
      </>
    );
  }

  if (viewMode === 'strand') {
    return (
      <Button
        variant="contained"
        color="primary"
        startIcon={<EmailIcon />}
        onClick={handleBookBand}
        sx={{
          position: 'absolute',
          top: 20,
          right: 20,
          backdropFilter: 'blur(4px)',
          backgroundColor: 'rgba(25, 118, 210, 0.9)',
          '&:hover': {
            backgroundColor: 'rgba(25, 118, 210, 1)',
          }
        }}
      >
        Book This Band
      </Button>
    );
  }

  const getStatusConfig = () => {
    switch (status) {
      case 'approved':
        return {
          icon: <CheckCircleIcon />,
          label: 'Approved',
          color: 'success'
        };
      case 'rejected':
        return {
          icon: <BlockIcon />,
          label: 'Rejected',
          color: 'error'
        };
      default:
        return {
          icon: <PendingIcon />,
          label: 'Pending Review',
          color: 'warning'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color as any}
      sx={{
        position: 'absolute',
        top: 20,
        right: 20,
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0,0,0,0.5)',
        '& .MuiChip-icon': {
          color: 'inherit'
        }
      }}
    />
  );
};

export default StatusActionDisplay;